import { useCallback } from 'react';
import { useAppContext } from '../context/AppContext';
import { usePhotos } from './usePhotos';
import { computeAutoSelection } from '../lib/autoSelectPrimary';
import { comparatorFor } from '../lib/huntDomain';

/**
 * Runs the auto-select-primary algorithm (numberhunter-todo.md item 3) and
 * writes only the primaries that actually changed.
 */
export function useAutoSelectPrimary() {
  const { derived, activeHunt } = useAppContext();
  const { photosByItem, primaryByItem } = derived;
  const { setPrimary } = usePhotos();

  const runAutoSelect = useCallback(async () => {
    const allPhotos = [...photosByItem.values()].flat();
    const assignment = computeAutoSelection(allPhotos, comparatorFor(activeHunt?.type));

    let updated = 0;
    for (const [itemKey, photoId] of assignment) {
      if (primaryByItem.get(itemKey)?.id !== photoId) {
        await setPrimary(itemKey, photoId);
        updated++;
      }
    }

    return { updated, total: assignment.size };
  }, [photosByItem, primaryByItem, setPrimary, activeHunt]);

  return { runAutoSelect };
}
